export default __webpack_public_path__ + "static/media/not_scaned.191153ff.svg";